import React, { useState, useEffect } from 'react';
import staticText from "../data/staticText"

function AccordionItem({ title, content, index, areAllOpen, onOpen, onClose }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (areAllOpen) {
      setIsOpen(true); // Synchronize with the "Apri tutto" button
    } else {
      setIsOpen(false); // Close all when "Chiudi tutto"
    }
  }, [areAllOpen]); // Synchronize when `areAllOpen` changes

  const toggleOpen = () => {
    const newState = !isOpen;
    setIsOpen(newState);

    if (newState) {
      onOpen(index); // Notify parent about opening
    } else {
      onClose(index); // Notify parent about closing
    }
  };

  return (
    <div className="border-b border-gray-300 mb-4">
      <button
        type="button"
        onClick={toggleOpen}
        className="w-full flex justify-between items-center px-4 py-2 text-left bg-gray-100 text-gray-700 font-semibold"
      >
        <span>{title}</span>
        <span>{isOpen ? '-' : '+'}</span>
      </button>
      {isOpen && (
        <div className="px-4 py-2 bg-white text-gray-600">
          <p dangerouslySetInnerHTML={{ __html: content.replace(/<br>/g, '<br />') }} />
        </div>
      )}
    </div>
  );
}

function SaleConditions({ onAllAccordionsOpen, formData}) {
  const [areAllOpen, setAreAllOpen] = useState(false);
  const [openAccordions, setOpenAccordions] = useState(new Set());


  const salesPoints = [
    {
        title: '1. MODALITA’ DI OFFERTA DEI LOTTI',
        content: `
          I lotti sono posti in vendita in locali aperti al pubblico da Meeting Art, che agisce in qualità di mandataria in esclusiva, in nome e per conto di ciascun Venditore, 
          il cui nome viene trascritto negli appositi registri di PS. Gli effetti della vendita influiscono sul venditore e Meeting Art
          non assume nei confronti dell’Aggiudicatario e di terzi in genere altra
          responsabilità oltre quella ad essa derivante dalla qualità di mandataria. Gli oggetti sono aggiudicati al miglior offerente e per contanti;
          in caso di contestazione l’oggetto verrà, a insindacabile giudizio del
          banditore, rimesso in vendita nel corso della stessa Asta all’ultima
          offerta valida pervenuta e nuovamente aggiudicato. Nel presentare
          la propria offerta, l’offerente si assume la responsabilità personale
          di corrispondere il prezzo di aggiudicazione comprensivo dei diritti
          d’asta, di ogni imposta dovuta e di qualsiasi altro onere applicabile,
          salvo ove sia espressamente convenuto per iscritto con Meeting
          Art prima della vendita, che l’offerente partecipi quale mandatario
          per conto di un terzo identificato e gradito a Meeting Art al quale
          si rivolgerà in esclusiva per tali pagamenti. Meeting Art si riserva la
          facoltà di ritirare dall’Asta qualsiasi lotto qualora le offerte in Asta
          non raggiungano il prezzo di riserva concordato con il Venditore. Il
          Banditore durante l’asta, ha la facoltà di abbinare o separare i lotti ed
          eventualmente variare l’ordine di vendita. In ogni caso, né Meeting
          Art, né suoi amministratori e dipendenti saranno responsabili per atti
          od omissioni relativi alla preparazione o alla conduzione dell'asta o per qualsiasi questione relativa all'opera.      
        `,
        titleEn: "1. BID PROCEDURES",
        contentEn: `The lots are sold in premises open to the public by Meeting Art which acts as Agent, on an exclusive basis, on behalf of each Seller, 
        whose names are registered in special books held at Meeting Art.The Sale shall have direct effects upon the Seller and Meeting Art 
        shall not be liable towards the Buyer or any third party except
        in respect of responsibilities deriving from its role as agent. The lots
        are knocked down to the highest bidder and for cash. If any dispute
        arises between two or more bidders, the lot will be put up for sale
        during the same auction to the last valid received and won again.
        Meeting Art will not accept any kind of transfer of the lots sold to third
        parties, and only the Buyer will be considered liable for the paymenT
        The participation at the auction in the name of and on behalf of third
        party is subject to the prior deposit, at Meeting Art premises, of a
        legal power of attorney and of satisfactory bank reference. Meeting
        Art reserves the right to withdraw any lot from the auction. The Auctioneer, at his / her sole discretion, can also withdraw lots if the bids
        do not reach the reserve price, as agreed between Meeting Art and
        the Seller. During the auction, the Auctioneer is entitled to join or separate any
        two or more lots and to change the order of the sale. In any case neither Meeting Art 
        nor its directors or employees are liable for any acts or omissions relating to the 
        preparation or conduct of the auction or for any matter relating to the sale of the work`
      }
        ,      
        {
            title: '2 . ECCEZIONE AL DIRITTO DI RECESSO',
            content: `
            Ai sensi dell’art. 59, comma 1, lettera m) del codice del consumo,
            qualora il contratto di vendita all’asta sia concluso con un offerente
            che abbia formulato un’offerta online tramite il sito e / o la piattaforma
            e possa essere qualificato come consumatore in base all’art. 3, comma 1, lett. a) del codice del consumo, l’Acquirente non disporrà del
            diritto di recesso, in quanto il metodo di vendita utilizzato è un’asta
            pubblica, come definita dall’art. 45, comma 1, lett. o) del codice del
            consumo.`,
            titleEn:`2 . EXCEPTION TO THE WITHDRAWAL RIGHT`,
            contentEn:`Pursuant to art.59, paragraph 1, letter m) of the consumer code if
            the auction sale contract is concluded with a bidder who has formulated an online offer
           via the site and / or platform and can be qualified as a consumer according to the art. 3, paragraph 1, letter. a) of the consumer code, 
           the Buyer will not have the withdrawal right, for the fact that the sales method used is a public auction, as defined by the 
            art. 45, paragraph 1, letter. o) of the consumer code.
            `,
        },
  
    {
        "title": "3. COMMISSIONI D'ASTA",
        "content": `L’aggiudicatario corrisponderà a Meeting Art una commissione d’asta per ciascun lotto pari al 25% sul prezzo di aggiudicazione.
                Sulle suddette commissioni Meeting Art applicherà il regime del
                margine (per maggiori informazioni su tale regime si rimanda alla
                pagina“Acquistare da Meeting Art”).
                In alcuni casi particolari l’IVA è applicata per i lotti consegnati da Venditori soggetti ad IVA i quali saranno soggetti, oltre all’IVA calcolata
                sulla commissione d’Asta, anche ad IVA sul prezzo di aggiudicazione.`,
        "titleEn":`3. AUCTION FEES`,
        "contentEn":`In addition to the hammer price the buyer shall pay, for
          each lot, a premium of 25% on the hammer price. Meeting Art will
          apply the Margin Scheme for more information regarding the margin scheme and these charges, please see Commission, Premium,
          VAT and charges in this catalogue). In some special cases, VAT is
          applied to items delivered by sellers subject to VAT which will be
          subject, in addition to VAT calculated on the auction commission,
          also for VAT calculated on the hammer price.
        `,
      },
      
    {
      "title": '4. PARTECIPAZIONE ALL\'ASTA',
      "content": `Prima di ogni Asta, a tutti i partecipanti e richiesto, aifini della validità
                di un'eventuale aggiudicazione, di compilare una scheda di partecipazione con i dati personali e le referenze bancarie. 
                Meeting Art può accettare mandati per l'acquisto (offerte scritte e telefoniche),
                effettuando rilanci mediante il Banditore con il pubblico partecipante all'Asta. Nel caso di due offerte scritte identiche per il medesimo
                lotto, lo stesso verrà aggiudicato all'Offerente la cui offerta sia stata ricevuta per prima. Meeting Art si riserva il diritto di rifiutare le offerte di
                Acquirenti non conosciuti a meno che venga rilasciato un deposito
                ad intera copertura del valore deilotti desiderati o, comunque, fornita altra adeguata garanzia. Si precisa che, in ogni caso, Meeting Art
                si riserva il diritto di non accettare offerte. All'atto dell'aggiudicazione
                Meeting Art potra chiedere all'Aggiudicatario le proprie generalità
                e, in caso di pagamento non immediato e in contanti, l’Aggiudicatario dovrà fornire a Meeting Art referenze bancarie congrue e comunque controllabili, in caso di evidente non rispondenza al vero o
                di incompletezza dei dati o delle circostanze di cui sopra, induse le
                informazioni fomite aisensi dell'art 5,0 comunque di inadeguatezza
                delle referenze bancarie, Meeting Artsi riserva di annullare i contratto divendita del lotto eventualmente aggiudicato.`
                ,
        "titleEn":`4. HOW TO PARTICIPATE`,
        "contentEn":`Before the auction each prospective Buyer must complete and sign
          a registration form including personal data and bank references, in
          order to bid through an assigned number. If the registration form is
          not completed and signed, any eventual sale will not be valid. Meeting Art is entitled to accept written or telephone bids on behalf
          of clients that do not attend the auction, making bids through the
          auctioneer in competition with the other bidders attending the Sale.
          If identical written bids are received from two or more parties for the
          same lot, the first bid received by Meeting Art shall take precedence. Meeting Art reserves the right to refuse bids from unidentified
          Buyers unless, a deposit covering the entire value of the lots desired, is paid. Meeting Art reserves the right not to accept bids. If the
          payment is not immediate and in cash, the Buyer has to supply a
          permanent address and verifiable bank details. If the data are not
          complete, accurate or sufficient, Meeting Art reserves the right to
          cancel the sale of the lot.
        `,
    },
    {
        "title": "5. DESCRIZIONE DEI LOTTI",
        "content": `Meeting Art agisce in qualità di mandataria dei Venditori e declina
                    ogni responsabilità in ordine alla descrizione degli oggetti contenuta
                    nei cataloghi, nella brochure ed in qualsiasi altro materiale illustrativo;
                    le descrizioni cosi come ogni altra indicazione o illustrazione sono
                    puramente indicative e non potranno generare affidamenti di alcun
                    tipo negli Aggiudicatari. Tutte le aste sono precedute da un'esposizione ai fini da permettere un esame approfondito sull'autenticità,
                    lo stato di conservazione, la provenienza, il tipo e la qualità dell'oggetto. Dopo l'aggiudicazione né Meeting Art, né Venditori potranno
                    essere ritenuti responsabili per vizi relativi allo stato di conservazione,
                    per l’errata attribuzione, l'autenticità, la provenienza, ll peso o la mancanza di qualità degli oggetti nè Meeting Art, nè il suo personale
                    potrà rlasciare qualsiasi garanzia in tal senso, salvo i casi previsti dalla
                    legge. Si informa il consumatore in merito ai diritti di cui è titolare ex
                    arT 130 del Codice del Consumo (in particolare in merito al diritto del
                    consumatore al ripristino, senza spese, della conformità del bene e
                    alla durata della garanzia) che non vi è difetto di conformità se, al momento dell'acquisto l'acquirente era a conoscenza del difetto ovvero
                    non poteva ignorarlo con l'ordinaria diligenza.`
                    ,
        "titleEn":`5. DESCRIPTION OF THE LOTS`,
        "contentEn":`Meeting Art acts as mere Agent of the Sellers and cannot be considered liable for the description of the lots in the catalogues, brochures and other publications. Statements in the catalogue, condition
                    reports or any other indication or illustration regarding the lots, are
                    purely statements of opinion and cannot be accounted as statements of warranty. Before every auction, an exhibition of the lots takes place in order to allow an in-depth evaluation of the authenticity,
                    the state of preservation, the provenance and the type and quality
                    of any loT After the Sale, neither Meeting Art nor the Sellers will be
                    liable for any defects concerning the state of preservation, the correctness of statements about attribution, authenticity, provenance,
                    weight or quality of any item. Neither Meeting Art nor its staff has the
                    authority to make or give any representation or warranty, except for
                    cases provided by law. We inform consumer about the rights it enjoys under arT 130 of the Consumer Code (in particular with regard
                    to the right of the consumer to repair, without charge, the conformity
                    of the goods and the duration of the guarantee) that there is no lack
                    of conformity if, at the time of purchase the buyer was aware of the
                    or could not ignore with ordinary diligence.
        `,

      },
      
    {
      title: '6. BASI D\'ASTA',
      content: `Le basi d'asta di ciascun lotto sono stampate sotto la descrizione degli stessi riportata nel catalogo e non indudono i diritti d'Asta
                dovutitali stime sono tuttavia effettuate con largo antico rispetto
                alla data dell'Asta e pertanto possono essere soggette a revisione.
                Anche le descrizioni dei lotti nel catalogo potranno essere soggette
                a revisione mediante comunicazioni al pubblico durante l'Asta.
                `,
    "titleEn":`6. STARTING BIDS`,
    "contentEn":`The estimates and the starting biddings regarding the possible Sale
                  price of each lot are printed under the description of every lot in the
                  catalogue and are not Buyer’s premium inclusive. Estimates and
                  starting bids are prepared well in advance so they can be subject to
                  revision. The description of the lots in the catalogue could be subject
                  to revision, as well. In that case an appropriate communications to
                  the public will be made during the auction.
    `,
    },
    {
        title: '7.PAGAMENTO DEL PREZZO',
        content: `Il pagamento totale del prezzo di aggiudicazione comprensivo dei
                    diritti d'Asta potra essere immediatamente preteso da Meeting Art,
                    in ogni caso dovrà essere effettuato per intero, in Euro, entro sette
                    giomi dall'aggiudicazione. Il pagamento ed il ritiro dei lotti dovranno
                    essere effettuati come specificato nella pagina “Acquistare da Meeting Art”. 
                    In difetto Meeting Art, fatto comunque salvo il risarcimento dei maggiori danni, potrà:
                    <br><br>
                    a)procedere per l'esecuzione coattiva degli obblighi nascenti dall'acquisto;
                    <br><br>
                    b)alienare il lotto a trattativa privata oppure in un'Asta successiva in
                    danno dell’ Aggiudicatario, trattenendo comunque atitolo dipenale
                    eventuali acconti ricevuti. l'oggetto sarà custodito da Meeting Art a
                    rischio e spese dell'Aggiudicatario fino a quando non sarà venduto
                    come sopra oppure restituito al Venditore su richiesta del medesimo. 
                    In ogni caso, fino alla data di restituzione o di vendita, l'Aggiudicatario sarà tenuto a corrispondere a Meeting Art una penale pari
                    agli interessi, calcolati sul prezzo di aggiudicazione più le commissioni d'Asta, al tasso interbancario in vigore maggiorato di due punti;
                    gli interessi così calcolati saranno applicati sulle somme dovute a
                    decorrere dall'ottavo giorno seguente la data dell'aggiudicazione.
                    `
                    ,
        "titleEn":`7. PAYMENT`,
        "contentEn":`Meeting Art is entitled to require from the Buyer immediate
                  payment in full and in Euro of the Hammer Price plus the Buyer’s
                  Premium. The payment must be made within seven days from the
                  purchase.
                  Instructions for payment and collection of purchased lots can be
                  found in the catalogue or in the website. If the Buyer fails to pay the
                  amount due Meeting Art, reserving the right to further damages,
                  shall be entitled to:
                  <br><br>
                  a) enforce the contractual purchase obligation.
                  <br><br>
                  b) arrange a resale of the Lot, through private treaty or during the
                  following auction, keeping as a penalty any amount already paid by
                  the Buyer. Meeting Art shall retain items sold at risk and Buyer’s own
                  expense until the selling of the lot or until the restitution to the Seller,
                  if required. In any case, until the sale date, The Buyer will have to pay
                  a penalty equal to the interest, calculated on the Hammer price plus
                  the Buyer’s premium, according to the interbank rate in force increased of two points: the interest so calculated shall be applied on the
                  amount from the eighth day following the Sale
        `,
    },
      
    {
        "title": "8. RITIRO DEI LOTTI",
        "content": `L'aggiudicatario, saldato il prezzo di aggiudicazione e le commissioni per i diritti d'Asta, dovrà ritirare i lotti acquistati a propria cura,
                    rischio e spese entro iterminispecificati nella pagina “Acquistare da
                    Meeting Art”. Decorso tale termine, Meeting Art sarà esonerata da
                    ogni responsabilità nei confronti dell'aggiudicatario in relazione alla
                    custodia, all'eventuale deterioramento degli oggetti e avrà diritto
                    di trasferire i lotti non ritirati a spese e rischio dell'acquirente presso
                    i propri uffici ovvero magazzini pubblici o privati. Su espressa richiesta
                    la Meeting Art potrà organizzare, a spese e rischio dell'Aggiudicatario il trasporto e l'assicurazione del lotto.
      `,
      "titleEn":`8. COLLECTION OF THE LOTS`,
      "contentEn":`The Buyer, after the payment of the Hammer price and the Buyer’s
        premium, has to collect the lots at his own risk and cost within the
        days specified in the paragraph “Buying at Meeting Art”. After this
        time, Meeting Art shall not be held liable by the Buyer for the custody or for any possible deterioration of the items. Moreover, Meeting
        Art will have the right to transfer lots which have not been collected at
        the risk and buyer’s own expense to its offices or warehouse.
      `,
    },
    {
        "title": "9. DEROGHE",
        "content": `Nonostante ogni disposizione contraria qui contenuta, Meeting
                    Art si riserva il diritto di concordare con gli aggiudicatari forme speciali di pagamento, di depositare in magazzino pubblico / privato o
                    vendere privatamente i lotti aggiudicati e non ritirati, di assicurare i
                    lotti aggiudicati, di risolvere controversie e contestazioni effettuate
                    da Aggiudicatari o contro gli stessi e in generale di intraprendere
                    qualsiasi iniziativa ritenuta opportuna al fine di riscuotere somme
                    dovute dall’Aggiudicatario e anche, a seconda delle circostanze, di
                    annullare la vendita aisensi degli articoli 13 e 14 e restituire il prezzo
                    all'Aggiudicatario.`,
        "titleEn":`9 . EXEMPTIONS`,
        "contentEn":`Despite any contrary provisions in these “Conditions of Sale”, Meeting Art reserves the right to agree with the Sellers special conditions
          of payment, to arrange for warehousing, to decide for the insurance
          of the object sold, to sell privately the lots sold uncollected, to settle
          any disputes made by or against the Buyers and, in general to take
          any action deemed appropriate for the collection of the amounts
          due by the Buyer and, if necessary, to cancel the Sale and return the
          price to the Buyer in accordance with articles 13 and 14 below.
        `,
    },
    {
        "title": "10. ESPORTAZIONE",
        "content": `Per tutti i lotti databili anteriormente ai 70 anni l'esportazione è
                    soggetta alle normative del Ministero Italiano per i Beni e le Attività
                    Culturali, Ufficio Esportazione. Meeting Art non può fornire alcuna
                    garanzia sul rilascio dell'attestato di Libera Circolazione né sui tempi necessari per lo stesso. Meeting Art può fornire assistenza per le
                    pratiche legate all'esportazione con una spesa aggiuntiva, a carico
                    dell'acquirente, di € 300,00 + IVA. Gli acquirenti sono tenuti all'osservanza di tutte le disposizioni legislative e regolamenti in vigore relativamente agli oggettisottoposti a notifica, con particolare riferimento
                    alla Legge n. 1089 del 1 Giugno 1939. L'esportazione di oggetti è
                    regolata dalla suddetta normativa e dalle leggi doganali e tributarie
                    in vigore. Meeting Art declina ogni responsabilità nei confronti degli
                    acquirenti in ordine ad eventuali restrizioni all'esportazione dei lotti
                    aggiudicati. l'aggiudicatario non potrà, in caso di esercizio del diritto
                    di prelazione daparte dello stato, pretendere dalla Meeting Art o dal
                    Venditore alcun rimborso od indennizzo. Il Decreto Legislativo del
                    22 gennaio 2004 n. 42 disciplina l'esportazione dei beni culturali al
                    di fuori del territorio della Repubblica Italiana, mentre l'esportazione
                    al di fuori della Comunità Europea è altresì assoggettata alla discplina prevista dal Regolamento CEE n. 3911 / 92 del 9 dicembre 1992,
                    «come modificato dal Regolamento CEE n. 2469 / 96 del 16 dicembre
                    1996 e dal Regolamento CEE n. 974 / 01 del 14 maggio 2001.
                    Meeting Art non risponde del rilascio dei relativi permessi previsti
                    né può garantirne il rilascio. La mancata concessione delle suddette
                    autorizzazioni non può giustificare l'annullamento dell'acquisto né il
                    mancato pagamento, che dovrà essere effettuato entro sette giorni
                    dalla chiusura dell'asta. Per esportazione di materiali derivati da specie protette come, ad esempio, corallo, avorio, tartaruga, coccodrillo, ossi di balena, corni di rinoceronte, etc., è necessaria una licenza
                    di esportazione CITES rilasciata dal Ministero dell'Ambiente e della
                    Tutela del Territorio.

                    Gli acquirenti che intendono esportare questi oggetti devono
                    provvedere a loro cura e spese al rilascio di detto certificato ed ad
                    informarsi presso il Paese di destinazione sulle Leggi che regolano
                    tali importazioni.`
                    ,
        "titleEn":`10. EXPORT`,
        "contentEn":`For all lots dating before age 70, their export is subject to the regulations of the Italian Ministry for Cultural Heritage and Activities, Export
                    Office. Meeting Art cannot provide any guarantees regarding the
                    issue of a Free Circulation nor on the time needed for the same.
                    Buyers are required to comply with all laws and regulations in force in
                    relation to the objects subject to notification, with particular reference
                    to AcT 1089 of 1 June 1939 The export of objects is governed by the
                    above regulations and customs laws and tax regulations. Meeting
                    Art disclaims any liability to any purchaser with regard to any restrictions on the export of the sold lots. The contractor shall not, in the
                    event of exercise of the right of first refusal on the part of the state,
                    claiming Meeting Art or the seller any refund or compensation. The
                    Legislative Decree of 22 January 2004 n. 42 regulating the export of
                    cultural goods outside the territory of the Italian Republic, while the
                    export outside the European Community is also subject to the regulations laid down by EEC Regulation no. 3911 / 92 of 9 December
                    1992, as amended by Regulation EEC n. 2469 / 96 of 16 December
                    1996 and the EEC Regulation no. 974 / 01 Meeting of May 14, 2001.
                    Meeting Art is not liable for issuing the relevant permits expected
                    nor can it guarantee their release.
                    The failure to grant such permits cannot justify the cancellation of
                    the purchase nor the non-payment, that will have to be made within
                    seven days from the end of the auction.
                    For export of material derived from endangered species, such as coral, ivory, tortoise, crocodile, whale bones, rhino horns, etc., you need
                    a CITES export permit issued by the Ministry for the Environment
                    and Territory .
                    Buyers wishing to export these objects must provide their care costs
                    and the issue of the certificate and to obtain information from the
                    country of destination on the laws that govern such imports.
        `,
    }
    ,
    {
        "title": "11. AUTENTICHE",
        "content": `Le opere sono vendute con le autentiche dei soggetti accreditati
                    al momento dell'acquisto se riportato in catalogo. La Meeting Art,
                    pertanto, non risponderà in alcun modo e ad alcun titolo nel caso
                    in cui si verifichino cambiamenti nei soggetti accreditati e deputati
                    a rilasciare autentiche relative alle varie opere. In caso di contestazioni fondate e accertate da Meeting Art per oggetti falsificati ad
                    arte, purché la relativa comunicazione scritta provenga a Meeting
                    Artentro 21 giorni dalla data della vendita, Meeting Art potrà, a sua
                    discrezione, annullare la vendita e rivelare all'aggiudicatario che lo
                    richieda il nome del Venditore, dandone preventiva comunicazione
                    a quest'ultimo.`,
        "titleEn":`11. AUTHENTICS`,
        "contentEn":`Lots are sold together with the authentication issued by the credit
                    expert at the moment of sale. Meeting Art declines any responsibility
                    in case of a change of the credited expert appointed to issue the
                    authentications of the various lots. If within 21 days from the sale date,
                    the Buyer has notified Meeting Art writing that he / she has a good
                    reason to believe that the lot concerned is a forgery and Meeting
                    Art accepts this objection, Meeting Art shall be entitled, at its sole
                    discretion, to cancel the Sale and disclose to the Buyer the name of
                    the Seller, giving prior notice to him / her.
        `,
    }
    ,
    {
        "title": "12. INFORMAZIONI SUI LOTTI",
        "content": `Le opere vengono vendute nel loro stato attuale. Non vengono
                    accettate offerte “al meglio” ovvero “salvo visione”. Consigliamo
                    pertanto ai potenziali acquirenti di assicurarsi dello stato di conservazione e della natura dei lotti prendendone visione prima della vendita. 
                    Il reparto responsabile dell'Asta sarà lieto di fornire su richiesta dei
                    rapporti informativi che rappresentano unicamente l'opinione dei
                    nostri esperti e potranno essere soggetti ad eventuali revisioni. Tutte
                    le informazioni sui punzoni dei metalli, sulla caratura, sulla qualità e
                    sul peso dell'oro, dei diamanti e delle pietre preziose colorate sono
                    da considerarsi puramente indicative e approssimative, Meeting Art
                    non potra essere ritenuta responsabile per eventuali errori contenuti
                    nelle suddette informazioni e per le falsificazioni ad arte degli oggetti
                    preziosi.
                    Alcuni pesi in catalogo sono stati determinati tramite misurazioni.
                    Questi dati devono essere considerati solo un'indicazione di massima
                     e non dovrebbero essere acquisiti come esatti. Meeting Art
                    non garantisce i certificati eventualmente acclusi ai preziosi eseguiti
                    da laboratori gemmologico indipendenti, nè tantomeno l'autenticità delle gemme sigillate in blister delle quali Meeting Art verifica
                    solamente l'integrità esteriore del sigillo, anche se riferimenti di tali
                    esami potranno essere citati a titolo informativo per gli aggiudicatari.
        `,
        "titleEn":`12. INFORMATIONS ON THE LOTS`,
        "contentEn":`Lots are sold in their actual state. We therefore recommend prospective buyers to check the state of conservation and nature of the lots
                    viewing them before the sale. The department in charge of the auction will be happy to provide upon request a condition report that
                    is solely the opinion of our experts and may be subject to possible
                    revisions. All the information concerning the marking of metals, the
                    carats and weight of gold, diamonds and colored precious stones,
                    are approximate and mere statements of opinion and cannot be
                    relied as a statements of warranty. Meeting Art shall not be held liable for any errors included in this information or for cases of forgery.
                    The weight of the stones, considered individually once removed
                    from the setting, is the approximate weight and not the “exact”
                    weighT Meeting Art does not guarantee the certificates attached to
                    precious objects made by gemological laboratories, if any. However,
                    reference to them can be made for information purposes.
        `,
    }
    ,
    {
        "title": "13. EVENTUALI PRETESE DI TERZI SUI LOTTI",
        "content": `In aggiunta ad ogni altro obbligo o diritto previsto dalle presenti
                    Condizioni di Vendita, Meeting Art nel caso in cui sia stata informata
                    o venga a conoscenza di un'eventuale pretesa o diritto di terzi inerente alla proprietà, possesso o detenzione del Lotto potrà, a sua
                    discrezione, trattenere in custodia il Lotto nelle more della composizione della controversia o per tutto il periodo ritenuto ragionevolmente necessario a tale composizione.
                    `,
        "titleEn":`13. ANY CLAIMS BY THIRD PARTIES ABOUT LOTS`,
        "contentEn":`In addition to all our rights and obligations under this agreement, if
                    Meeting Art becomes acquainted with a claim from a third party that
                    has a right of to property, possession or control of the Lots, shall be
                    entitled to retain possession of the Lots until the dispute is resolved.
      `,
    }
    ,
    {
        "title": "14. ANTIRICICLAGGIO",
        "content": `Il cliente prende atto e accetta, ai sensi e per gli effetti dell'arT 22
                    D. Lgs n. 231 / 2007 (Decreto Antiriciclaggio), di fornire tutte le informazioni necessarie ed aggiornate per consentire a Meeting Art di
                    adempiere agli obblighi di adeguata verifica della clientela. Resta inteso che il perfezionamento dell'operazione è subordinato al rilascio
                    da parte del Cliente delle informazioni richieste da Meeting Art per
                    l'adempimento dei suddetti obblighi.
                    Ai sensi dell’arT 42 D. Lgs n. 231 / 07, Meeting Art si riserva la facoltà
                    di astenersi e non concludere l'operazione nel caso di impossibilità
                    oggettiva di effettuare l'adeguata verifica della clientela.
                    `,
        "titleEn":`14. ANTI - MONEY LAUDERING REGULATIONS`,
        "contentEn":`According to the arT 22 D. Lgsn n. 231 / 2007 (Anti-money laundering Decree) customer takes note and accepts to provide all the
                    necessary and updated information to allow Meeting Art to fulfill
                    adequate examination obligations of its customers. It is understood
                    that the improvement of the operation is subjected to the realise by
                    the Customer of the information requested by Meeting Art for the
                    fulfillment of the above mentioned obligations.
                    Pursuant to arT 42 D Lgs n. 231 / 07 Meeting Art reserves the right
                    to abstain and to not conclude the operation in case of objective
                    impossibility to make the adequate examination of the clientele.
      `,
    }
    ,
    {
        "title": "15. LEGGE APPLICABILE",
        "content": `ll presente contratto è regolato dalla legge italiana.`,
        "titleEn":`15. APPLICABLE LAW`,
        "contentEn":`This contract is governed by Italian law.
      `,
    }
    ,
    {
        "title": "16. CONTROVERSIE",
        "content": `Le presenti Condizioni di Vendita sono accettate automaticamente
                    «da quanti concorrono all’Asta e sono a disposizione di qualsiasi 
                    interessato che ne faccia richiesta.
                    <br><br>
                    16.2 Nel caso di Acquirente Consumatore, per ogni controversia
                    relativa all'applicazione e interpretazione delle presenti Condizioni
                    Generali di Vendita è stabilita la competenza del Foro di Vercelli. Si
                    precisa che la clausola di deroga al Foro del consumatore è stata
                    oggetto di specifica trattativa individuale ed il consumatore dichiara
                    di accettarne il contenuto.
                    <br><br>
                    16.3 Ai sensi dell'art. 141 sexies c. 3 del Codice del Consumo, ove
                    applicabile, Meeting Art informa l'acquirente Consumatore che,
                    nel caso egli abbia presentato un reclamo direttamente a Meeting
                    Art, a seguito del quale tuttavia non sia stato possbile risolvere la
                    controversia così insorta, MeetingArt fornirà le informazioni in merito
                    all'Organismo o agli Organismi di Alternative Despute Resolutuion
                    (ADR) per la risoluzione extragiudiziale delle controversie relative ad
                    obbligazioni derivanti da un contratto concluso in base alle presenti
                    Condizioni Generali di Vendita, precisando se intenda avvalersi o
                    meno di tali organismi per risolvere la controversia stessa.
                    <br><br>
                    E' fatto salvo, in ogni caso, il diritto dell'Acquirente Consumatore di
                    adire il giudice ordinario competente della controversia derivante
                    dall'interpretazione delle presenti Condizioni Generali di Vendita,
                    qualunque sia l'esito della procedura extragiudiziale delle controversie relative airapporti di consumo mediante ricorso alle procedure di
                    cui alla parte V Titolo II bis Codice del Consumo.`,
        "titleEn":`16. DISPUTES`,
        "contentEn":`These Conditions of Sale are automatically accepted by those who
                    participate in the Auction and are available to any interested party
                    who requests them.
                    <br><br>
                    16.2 In case of a Consumer Buyer, the jurisdiction of the Court of
                    Vercelli is established for any dispute relating to the application and
                    interpretation of these General Conditions of Sale. It is specified that
                    the derogating clause from the consumer’s Court was the subject of
                    specific individual negotiation and the consumer declares to accept
                    its content.
                    <br><br>
                    16.3 Pursuant to art. 141 sexies c. 3 of the Consumer Code, where
                    applicable, Meeting Art informs the Consumer purchaser that, in the
                    event that he has submitted a complaint directly to Meeting Art, following which it has not been however possible to resolve the dispute
                    thus arised, Meeting Art will provide the information regarding the
                    Alternative Dispute Resolutuion (ADR) Organisation or Organisations for the extrajudicial dispute resolution relating to obligations
                    derived from a contract concluded on the basis of these General
                    Conditions of Sale, specifying whether or not it intends to make use
                    of such entities to resolve the controversy itself.
                    <br><br>
                    In any case, the right of the Consumer Buyer to appeal to the competent ordinary judge of the dispute arised from the interpretation
                    of these General Conditions of Sale is reserved, regardless of the
                    outcome of the extrajudicial procedure of disputes relating to consumer relations through recourse to the procedures referred to in
                    part V, Title II bis Consumer Code.
      `,
    }
      
    // Aggiungi altri punti come necessario
  ];
  const totalAccordions = salesPoints.length;

  const toggleAllAccordion = () => {
    const newAreAllOpen = !areAllOpen;
    setAreAllOpen(newAreAllOpen);

    if (newAreAllOpen) {
      const allIndexes = new Set(salesPoints.map((_, i) => i));
      setOpenAccordions(allIndexes);
      onAllAccordionsOpen(true);
    } else {
      setOpenAccordions(new Set());
      onAllAccordionsOpen(false);
    }
  };

  const handleOpenAccordion = (index) => {
    setOpenAccordions((prev) => {
      const updated = new Set(prev);
      updated.add(index);

      // Check if all are open
      if (updated.size === totalAccordions) {
        onAllAccordionsOpen(true);
      }

      return updated;
    });
  };

  const handleCloseAccordion = (index) => {
    setOpenAccordions((prev) => {
      const updated = new Set(prev);
      updated.delete(index); 

        onAllAccordionsOpen(false);      
      

      return updated;
    });
  };

  // Check if all accordion items are open
  const allAccordionsOpen = openAccordions.size === totalAccordions;

  return (
    <div className="w-full max-w-5xl p-8 bg-white rounded-lg shadow-md relative">
      <button
        type="button"
        onClick={toggleAllAccordion}
        className="absolute top-4 right-4 px-4 py-2 primary-color text-white font-bold rounded transition"
      >
        {areAllOpen ? staticText[formData.nationality]?.close : staticText[formData.nationality]?.open}
      </button>
      <h3 className="text-center text-2xl font-bold mb-6 md:mt-0 mt-10">  {staticText[formData.nationality]?.sales}</h3>
      <p className="mt-5 mb-5 font-bold text-xl">
      {staticText[formData.nationality]?.salesParagraph}
      </p>
      {salesPoints.map((point, index) => (
        <AccordionItem
          key={index}
          title={formData.nationality === "it" ? point.title : point.titleEn} 
          content={formData.nationality === "it" ? point.content : point.contentEn}  
          index={index}
          areAllOpen={areAllOpen}
          onOpen={handleOpenAccordion}
          onClose={handleCloseAccordion}
        />
      ))}
    </div>
  );
}

export default SaleConditions;